document.addEventListener('DOMContentLoaded',()=>{document.querySelector('.ac-menu')?.addEventListener('click',()=>document.querySelector('.ac-nav')?.classList.toggle('open'));});


// Cart quantity controls: +/- submit Shopify's native cart update form; remove sets quantity to zero.
document.addEventListener('DOMContentLoaded',()=>{
  const cartForm=document.querySelector('#cart-update-form');
  if(!cartForm) return;
  cartForm.querySelectorAll('[data-qty-change]').forEach(button=>button.addEventListener('click',()=>{
    const input=button.parentElement.querySelector('.qty-input');
    if(!input) return;
    const current=parseInt(input.value,10)||0;
    input.value=Math.max(0,current+(parseInt(button.dataset.qtyChange,10)||0));
    cartForm.requestSubmit();
  }));
  cartForm.querySelectorAll('[data-remove-item]').forEach(button=>button.addEventListener('click',()=>{
    const key=button.dataset.removeItem;
    const input=Array.from(cartForm.querySelectorAll('.qty-input')).find(el=>el.name==='updates['+key+']');
    if(input){input.value='0';cartForm.requestSubmit();}
  }));
});


// Persistent light/dark mode toggle.
document.addEventListener('DOMContentLoaded',()=>{
  const button=document.querySelector('.theme-toggle');
  if(!button) return;
  const label=button.querySelector('.theme-toggle-label');
  const icon=button.querySelector('.theme-toggle-icon');
  const applyTheme=(theme)=>{
    const light=theme==='light';
    document.body.dataset.theme=light?'light':'dark';
    button.setAttribute('aria-pressed',String(light));
    button.setAttribute('aria-label',light?'Dunkles Design aktivieren':'Helles Design aktivieren');
    button.title=light?'Zum dunklen Design wechseln':'Zum hellen Design wechseln';
    if(label) label.textContent=light?'Dunkel':'Hell';
    if(icon) icon.textContent=light?'☾':'☼';
    try{localStorage.setItem('armageddon-theme',light?'light':'dark')}catch(e){}
  };
  let saved='dark';
  try{saved=localStorage.getItem('armageddon-theme')||'dark'}catch(e){}
  applyTheme(saved);
  button.addEventListener('click',()=>applyTheme(document.body.dataset.theme==='light'?'dark':'light'));
});
